import { render } from "./FurnitureGameRoom.vue?vue&type=template&id=890fbc5e&scoped=true"
import script from "./FurnitureGameRoom.vue?vue&type=script&lang=js"
export * from "./FurnitureGameRoom.vue?vue&type=script&lang=js"

import "./FurnitureGameRoom.vue?vue&type=style&index=0&id=890fbc5e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-890fbc5e"

export default script